import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'dsp-no-data-table',
  templateUrl: './no-data-table.component.html'
})
export class NoDataTableComponent {
  @Input()
  public id = '';

  @Input()
  public noDataLabel = '';

  @Input()
  public headers: any[] = [];
}
